export default "__VITE_ASSET__7Qw2cuVd__"